module.exports = "/images/vendor/leaflet-search/loader.gif?f9b7a75b186911a1b04d08f8db305b7a";